import { useRef, useState } from "react";
import { X } from "lucide-react";

export default function ZoneEditor({ imageUrl, zones, onChange }) {
  const boxRef = useRef(null);
  const [draft, setDraft] = useState(null);

  const norm = (e) => {
    const r = boxRef.current.getBoundingClientRect();
    return {
      x: Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)),
      y: Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)),
    };
  };
  const down = (e) => { e.preventDefault(); const p = norm(e); setDraft({ x0: p.x, y0: p.y, x1: p.x, y1: p.y }); };
  const move = (e) => { if (draft) { const p = norm(e); setDraft((d) => ({ ...d, x1: p.x, y1: p.y })); } };
  const up = () => {
    if (!draft) return;
    const z = { x: Math.min(draft.x0, draft.x1), y: Math.min(draft.y0, draft.y1),
                w: Math.abs(draft.x1 - draft.x0), h: Math.abs(draft.y1 - draft.y0) };
    if (z.w > 0.01 && z.h > 0.01) onChange([...zones, z]);
    setDraft(null);
  };

  const rect = (z, i, isDraft) => (
    <div key={isDraft ? "draft" : i}
         className={`absolute border-2 ${isDraft ? "border-orange-400 bg-orange-400/30" : "border-red-500 bg-black/70"}`}
         style={{ left: `${z.x * 100}%`, top: `${z.y * 100}%`, width: `${z.w * 100}%`, height: `${z.h * 100}%` }}>
      {!isDraft && (
        <button onMouseDown={(e) => e.stopPropagation()} data-testid="zone-delete-btn"
                onClick={(e) => { e.stopPropagation(); onChange(zones.filter((_, k) => k !== i)); }}
                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center">
          <X size={10} />
        </button>
      )}
    </div>
  );

  const d = draft && { x: Math.min(draft.x0, draft.x1), y: Math.min(draft.y0, draft.y1),
                       w: Math.abs(draft.x1 - draft.x0), h: Math.abs(draft.y1 - draft.y0) };

  return (
    <div ref={boxRef} data-testid="zone-editor" onMouseDown={down} onMouseMove={move}
         onMouseUp={up} onMouseLeave={up}
         className="relative select-none cursor-crosshair rounded-xl overflow-hidden border border-neutral-200">
      <img src={imageUrl} alt="fotograma de referencia" className="w-full pointer-events-none" draggable={false} />
      {zones.map((z, i) => rect(z, i, false))}
      {d && rect(d, null, true)}
    </div>
  );
}
